export const REDUCER_NAME = "globalSearch";

export const ACTION_TYPES = {
  searchOpenChange: `${REDUCER_NAME}/searchOpenChange`,
};
